"use client"

import { OneTagScript } from "@/components/pixel-scripts/one-tag-scripts/one-tag-script"
import { usePixelInjectionPermissionSisal } from "@/hooks/use-pixel-injection-permission"

export function OnetagSignupAllPagesPixelScriptSisal() {
  const canInjectPixels = usePixelInjectionPermissionSisal()

  if (!canInjectPixels) return null

  return <OneTagScript segmentGroup="690" scriptId="DT9-all-pages" />
}
